var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-card", { staticClass: "mb5" }, [
        _c(
          "div",
          [
            _c(
              "el-tabs",
              {
                staticStyle: { "margin-top": "-10px" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _vm.showCollect
                  ? _c(
                      "el-tab-pane",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:exceptionManagementCenter:Collect",
                            expression:
                              "'btn:exceptionManagementCenter:Collect'",
                            arg: "remove",
                          },
                        ],
                        attrs: { name: "0" },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("GlobalSetObj.Collect")) + " "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.showExpress
                  ? _c(
                      "el-tab-pane",
                      {
                        directives: [
                          {
                            name: "permit",
                            rawName: "v-permit:remove",
                            value: "btn:exceptionManagementCenter:Express",
                            expression:
                              "'btn:exceptionManagementCenter:Express'",
                            arg: "remove",
                          },
                        ],
                        attrs: { name: "1" },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("collectionCenter.expressDelivery")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.showCollect || _vm.showExpress
              ? _c(
                  "el-form",
                  { attrs: { "label-position": "top", size: "small" } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 7 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("template", { slot: "label" }, [
                                  _c(
                                    "div",
                                    { staticClass: "selectLabel" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          model: {
                                            value:
                                              _vm.queryForm.params.timeType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryForm.params,
                                                "timeType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryForm.params.timeType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            key: "1",
                                            attrs: {
                                              label: _vm.$t(
                                                "orderCenterCont.problemTime"
                                              ),
                                              value: 1,
                                            },
                                          }),
                                          _vm.activeName === "0"
                                            ? [
                                                _c("el-option", {
                                                  key: "2",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "collectionCenter.orderCreateT"
                                                    ),
                                                    value: 2,
                                                  },
                                                }),
                                                _c("el-option", {
                                                  key: "3",
                                                  attrs: {
                                                    label:
                                                      _vm.$t(
                                                        "newOrder.lanshouT"
                                                      ),
                                                    value: 3,
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: false,
                                    "default-time": ["00:00:00", "23:59:59"],
                                    format:
                                      _vm.$i18n.locale === "zh"
                                        ? _vm.zhDate
                                        : _vm.ptDate,
                                    placeholder: _vm.$t(
                                      "newOrder.SelectDatetime"
                                    ),
                                    "range-separator": "~",
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                  },
                                  model: {
                                    value: _vm.timeValue,
                                    callback: function ($$v) {
                                      _vm.timeValue = $$v
                                    },
                                    expression: "timeValue",
                                  },
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("template", { slot: "label" }, [
                                  _c(
                                    "div",
                                    { staticClass: "selectLabel" },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          model: {
                                            value:
                                              _vm.queryForm.params.numberType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryForm.params,
                                                "numberType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryForm.params.numberType",
                                          },
                                        },
                                        [
                                          _vm.activeName === "0"
                                            ? [
                                                _c("el-option", {
                                                  key: "1",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "collectionCenter.Barcode"
                                                    ),
                                                    value: 0,
                                                  },
                                                }),
                                                _c("el-option", {
                                                  key: "2",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "collectionCenter.lanshouOrderNum"
                                                    ),
                                                    value: 1,
                                                  },
                                                }),
                                                _c("el-option", {
                                                  key: "3",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "collectionCenter.customerOrderNum"
                                                    ),
                                                    value: 2,
                                                  },
                                                }),
                                              ]
                                            : [
                                                _c("el-option", {
                                                  key: "2",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "collectionCenter.waybillNumber"
                                                    ),
                                                    value: 3,
                                                  },
                                                }),
                                                _c("el-option", {
                                                  key: "3",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "GlobalSetObj.ScanNumber"
                                                    ),
                                                    value: 4,
                                                  },
                                                }),
                                              ],
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.CanBeEnteredMultiple2000"
                                    ),
                                    rows: 1,
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.inputValue,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "inputValue",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.inputValue",
                                  },
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("orderCenterCont.CustomerName"),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseChoose"
                                      ),
                                      "remote-method": _vm.getCustomerPage,
                                      clearable: "",
                                      "collapse-tags": "",
                                      filterable: "",
                                      multiple: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                    },
                                    on: {
                                      clear: function ($event) {
                                        return _vm.getCustomerPage("")
                                      },
                                      focus: function ($event) {
                                        return _vm.getCustomerPage("", true)
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.customerIdList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "customerIdList",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.customerIdList",
                                    },
                                  },
                                  _vm._l(_vm.customerNameList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.username,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.MerchantName"
                                  ),
                                  size: "small",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseChoose"
                                      ),
                                      "remote-method": _vm.getMerchantList,
                                      clearable: "",
                                      "collapse-tags": "",
                                      filterable: "",
                                      multiple: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                    },
                                    on: {
                                      clear: function ($event) {
                                        return _vm.getMerchantList("")
                                      },
                                      focus: function ($event) {
                                        return _vm.getMerchantList("", true)
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.merchantCodeList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "merchantCodeList",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.merchantCodeList",
                                    },
                                  },
                                  _vm._l(_vm.merchantList, function (item) {
                                    return _c("el-option", {
                                      key: item.merchantCode,
                                      attrs: {
                                        label:
                                          item.merchantName +
                                          " - " +
                                          item.merchantCode,
                                        value: item.merchantCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _vm.activeName === "1"
                          ? _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("template", { slot: "label" }, [
                                      _c(
                                        "div",
                                        { staticClass: "selectLabel" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              model: {
                                                value:
                                                  _vm.queryForm.params.siteType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryForm.params,
                                                    "siteType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryForm.params.siteType",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                key: "1",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "driver.registrantHub"
                                                  ),
                                                  value: 0,
                                                },
                                              }),
                                              _c("el-option", {
                                                key: "2",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "GlobalSetObj.preEntrega"
                                                  ),
                                                  value: 1,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseChoose"
                                          ),
                                          "remote-method":
                                            _vm.remoteGetSiteList,
                                          clearable: "",
                                          filterable: "",
                                          multiple: "",
                                          remote: "",
                                          "reserve-keyword": "",
                                        },
                                        on: {
                                          focus: function ($event) {
                                            return _vm.remoteGetSiteList("")
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.queryForm.params.siteSelectList,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryForm.params,
                                              "siteSelectList",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryForm.params.siteSelectList",
                                        },
                                      },
                                      _vm._l(_vm.siteList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("template", { slot: "label" }, [
                                  _vm.activeName === "0"
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "compensationManagement.orderStatus"
                                            )
                                          )
                                        ),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "collectionCenter.shipmentStatus"
                                            )
                                          )
                                        ),
                                      ]),
                                ]),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t("GlobalSetObj.all"),
                                      clearable: "",
                                      filterable: "",
                                      multiple: "",
                                      size: "small",
                                    },
                                    model: {
                                      value:
                                        _vm.queryForm.params.collectStatusList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "collectStatusList",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.collectStatusList",
                                    },
                                  },
                                  _vm._l(
                                    _vm.selectStatusList,
                                    function (item, ind) {
                                      return _c("el-option", {
                                        key: ind,
                                        attrs: {
                                          label: item.label,
                                          value: item.code,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.problemReason"),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "GlobalSetObj.pleaseChoose"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                      multiple: "",
                                    },
                                    on: { focus: _vm.handleFocus },
                                    model: {
                                      value:
                                        _vm.queryForm.params.problemTypeIdList,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryForm.params,
                                          "problemTypeIdList",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "queryForm.params.problemTypeIdList",
                                    },
                                  },
                                  _vm._l(
                                    _vm.causeProblemPageList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.dictDescribe,
                                          value: item.problemId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.activeName === "1"
                          ? _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("newOrder.RecipientState"),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseChoose"
                                          ),
                                          clearable: "",
                                          filterable: "",
                                          multiple: "",
                                        },
                                        model: {
                                          value:
                                            _vm.queryForm.params.receiveStates,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryForm.params,
                                              "receiveStates",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryForm.params.receiveStates",
                                        },
                                      },
                                      _vm._l(_vm.StateList, function (item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.activeName === "1"
                          ? _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("login.addressIssueType"),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "GlobalSetObj.pleaseChoose"
                                          ),
                                          clearable: "",
                                          filterable: "",
                                          multiple: "",
                                        },
                                        model: {
                                          value:
                                            _vm.queryForm.params
                                              .addressIssueTypeList,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryForm.params,
                                              "addressIssueTypeList",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryForm.params.addressIssueTypeList",
                                        },
                                      },
                                      _vm._l(
                                        _vm.addressProblemList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.label,
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          {
                            staticStyle: { width: "auto" },
                            attrs: { span: 4 },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "27px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.enterSearch },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("newOrder.search")) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "info" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("newOrder.reset")) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showCollect || _vm.showExpress
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.clickBatchRegistration },
                      },
                      [_vm._v(_vm._s(_vm.$t("driver.batchRegistration")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-upload2", size: "small" },
                        on: { click: _vm.exportOrder },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("navbar.export")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.orderNumberExport },
                      },
                      [_vm._v(_vm._s(_vm.$t("placeOrder.BatchExport")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("el-card", [
        _vm.showCollect || _vm.showExpress
          ? _c(
              "div",
              {
                staticClass: "box-card",
                staticStyle: { "margin-top": "10px" },
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName === "0",
                        expression: "activeName === '0'",
                      },
                    ],
                    ref: "tableRef",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      "header-cell-style": {
                        background: "#f2f2f2",
                        color: "black",
                      },
                      border: "",
                      height: "520",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.serial"),
                        align: "center",
                        type: "index",
                        width: "70",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("orderCenterCont.problemTime"),
                        prop: "createTime",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.lanshouOrderNum"),
                        prop: "orderNumber",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.Barcode"),
                        prop: "scanNumber",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.customerOrderNum"),
                        prop: "customerNumber",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("orderCenterCont.CustomerName"),
                        prop: "customerName",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.MerchantName"),
                        "show-overflow-tooltip": true,
                        prop: "merchantName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("compensationManagement.orderStatus"),
                        prop: "collectStatusName",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("newOrder.orderCreateTime"),
                        prop: "orderCreateTime",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("newOrder.clientExitTime"),
                        prop: "customerSendTime",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("newOrder.lanshouT"),
                        prop: "scanTime",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.problemReason"),
                        prop: "problemTypeName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.picture"),
                        prop: "problemImg",
                        width: "160",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "verifier",
                                    on: {
                                      click: function ($event) {
                                        return _vm.imageSee(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.problemImg
                                            ? _vm.$t("home.clickSee")
                                            : "--"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1740772542
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.remark"),
                        prop: "problemReason",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.registrar"),
                        prop: "problemName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("driver.registrantHub"),
                        prop: "registrantSiteName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "collectionCenter.RegistrationPositionLongitude"
                        ),
                        prop: "registrationLng",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "collectionCenter.RegistrationPositionLatitude"
                        ),
                        prop: "registrationLat",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label:
                          _vm.$t(
                            "collectionCenter.DistanceFromReceivingAddress"
                          ) + "(M)",
                        prop: "distanceToRecipient",
                        width: "160",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName === "1",
                        expression: "activeName === '1'",
                      },
                    ],
                    ref: "tableRef",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      "header-cell-style": {
                        background: "#f2f2f2",
                        color: "black",
                      },
                      border: "",
                      height: "520",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.serial"),
                        align: "center",
                        type: "index",
                        width: "70",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("orderCenterCont.problemTime"),
                        prop: "createTime",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.waybillNumber"),
                        prop: "orderNumber",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.ScanNumber"),
                        prop: "scanNumber",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("newOrder.waybillStatus"),
                        prop: "waybillStatusName",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.problemReason"),
                        prop: "problemTypeName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("login.addressIssueType"),
                        prop: "addressIssueTypeName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("scripting.damagedItems"),
                        prop: "damagedItemsTypeName",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("orderCenterCont.CustomerName"),
                        prop: "customerName",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.MerchantName"),
                        "show-overflow-tooltip": true,
                        prop: "merchantName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("orderCenterCont.BelongsToTheRegion"),
                        prop: "regionName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.preEntrega"),
                        prop: "preDeliverStationName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("newOrder.RecipientState"),
                        prop: "receiveState",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("Resource.picture"),
                        prop: "problemImg",
                        width: "160",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "verifier",
                                    on: {
                                      click: function ($event) {
                                        return _vm.imageSee(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.problemImg
                                            ? _vm.$t("home.clickSee")
                                            : "--"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1740772542
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.remark"),
                        prop: "problemReason",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("collectionCenter.registrar"),
                        prop: "problemName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("driver.registrantHub"),
                        prop: "registrantSiteName",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "collectionCenter.RegistrationPositionLongitude"
                        ),
                        prop: "registrationLng",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "collectionCenter.RegistrationPositionLatitude"
                        ),
                        prop: "registrationLat",
                        width: "160",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label:
                          _vm.$t(
                            "collectionCenter.DistanceFromReceivingAddress"
                          ) + "(M)",
                        prop: "distanceToRecipient",
                        width: "160",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-pagination", {
                  staticStyle: { margin: "10px 0", float: "right" },
                  attrs: {
                    "current-page": _vm.queryForm.pageNumber,
                    "page-size": _vm.queryForm.pageSize,
                    "page-sizes": [10, 50, 100, 500, 1000],
                    total: _vm.queryForm.total,
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
                _c("batchRegistration", {
                  ref: "batchRegistrationRef",
                  attrs: {
                    "active-name": _vm.activeName,
                    "cause-problem-list": _vm.causeProblemList,
                  },
                  on: { search: _vm.enterSearch },
                }),
                _c("imageSeeDialog", { ref: "imageSeeDialogRef" }),
              ],
              1
            )
          : _vm._e(),
      ]),
      !_vm.showCollect && !_vm.showExpress
        ? _c(
            "div",
            { staticClass: "flx-center", staticStyle: { "font-size": "25px" } },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("driver.grantSubpagePermission")) + " "
              ),
            ]
          )
        : _vm._e(),
      _c("orderNumberExport", { ref: "OrderExport" }),
      _c("exportTip", { ref: "exportTipRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }